/**
 * Controller: ReportsListCreateModal
 */
angular.module('acme.view.application.reports.list.createModal.controllers', [
  'acme.common.service.validate'
])
.controller('ReportsListCreateModalController', [ '$scope', '$uibModalInstance', 'ValidateService', 'Reports', 'Datasources', function ($scope, $uibModalInstance, ValidateService, Reports, Datasources) {

    $scope.errors = [];

    $scope.isSubmitted = false;

    $scope.model = {
      reportName: '',
      reportDescription: '',
      dataSourceName: ''
    };
    
    $scope.flags = {
      showDataSources: true
    };

    $scope.datasources = Datasources;
    $scope.reports = Reports;

    $scope.init = function() {

    };

    $scope.isValidName = function () {
      var r = true;
      if ($scope.isSubmitted) {
        r = ValidateService.validate([
          { len: { value: $scope.model.reportName} }
        ]);
      }

      return r;
    };

    $scope.hasDatasource = function () {
      var r = true;
      if ($scope.isSubmitted) {
        r = ValidateService.validate([
          { len: { value: $scope.model.dataSourceName} }
        ]);
      }

      return r;
    };

    $scope.selectDataSource = function (ds) {
      $scope.model.dataSourceName = ds.collectionName;
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.isUnique = function() {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model.reportName),
        r = true;

      for (i=0,ii=$scope.reports.length;i<ii;i++) {
        trimmed = $scope.trim($scope.reports[i].name);
        if (trimmedCurrent === trimmed) {
          r = false;
          break;
        }
      }

      return r;

    };

    $scope.done = function() {
      $scope.isSubmitted = true;
      $scope.errors = [];

      if ($scope.isUnique()) {
        if (ValidateService.validate([
          { len: { value: $scope.model.reportName } },
          { len: { value: $scope.model.dataSourceName } }
        ])) {
          $scope.success();
        } else {
          $scope.errors.push({ message: 'Please correct the errors below' });
        }
      }else{
        $scope.errors.push({ message: 'A report list named "' + $scope.model.reportName + '" already exists' });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model);
    };

    $scope.init();

}]);